import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { FilterIcon, RefreshCcwIcon, SearchIcon } from 'lucide-react';
interface FiltersPanelProps {
  filters: {
    clientCode: string;
    statusCode: string;
    search: string;
  };
  setFilters: React.Dispatch<React.SetStateAction<{
    clientCode: string;
    statusCode: string;
    search: string;
  }>>;
  onApply: () => void;
  onReset: () => void;
}
export function FiltersPanel({
  filters,
  setFilters,
  onApply,
  onReset
}: FiltersPanelProps) {
  return <Card className="border-gray-200 bg-white shadow-sm mb-6" data-id="element-39">
      <CardHeader className="pb-4 border-b border-gray-200" data-id="element-40">
        <div className="flex items-center justify-between" data-id="element-41">
          <CardTitle className="text-lg font-medium flex items-center space-x-2" data-id="element-42">
            <FilterIcon className="w-5 h-5 text-muted-foreground" data-id="element-43" />
            <span data-id="element-44">Filtros de Logs</span>
          </CardTitle>
          <div className="flex space-x-2" data-id="element-45">
            <Button variant="outline" size="sm" onClick={onReset} className="h-8" data-id="element-46">
              <RefreshCcwIcon className="w-3.5 h-3.5 mr-2" data-id="element-47" />
              Restablecer
            </Button>
            <Button size="sm" onClick={onApply} className="h-8" data-id="element-48">
              Aplicar Filtros
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-6" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-50">
          <div className="space-y-2" data-id="element-51">
            <label className="text-sm font-medium text-muted-foreground" data-id="element-52">
              Código de Cliente
            </label>
            <Select value={filters.clientCode} onChange={e => setFilters(prev => ({
            ...prev,
            clientCode: e.target.value
          }))} className="bg-muted/50" data-id="element-53">
              <option value="ALL" data-id="element-54">Todos los Clientes</option>
              <option value="APP-WEB" data-id="element-55">APP-WEB</option>
              <option value="APP-IOS" data-id="element-56">APP-IOS</option>
              <option value="APP-AND" data-id="element-57">APP-AND</option>
              <option value="API-EXT" data-id="element-58">API-EXT</option>
              <option value="SYS-CRON" data-id="element-59">SYS-CRON</option>
            </Select>
          </div>

          <div className="space-y-2" data-id="element-60">
            <label className="text-sm font-medium text-muted-foreground" data-id="element-61">
              Código de Estado
            </label>
            <Select value={filters.statusCode} onChange={e => setFilters(prev => ({
            ...prev,
            statusCode: e.target.value
          }))} className="bg-muted/50" data-id="element-62">
              <option value="ALL" data-id="element-63">Todos los Estados</option>
              <option value="200" data-id="element-64">2xx Éxito</option>
              <option value="400" data-id="element-65">4xx Error de Cliente</option>
              <option value="500" data-id="element-66">5xx Error de Servidor</option>
            </Select>
          </div>

          <div className="space-y-2" data-id="element-67">
            <label className="text-sm font-medium text-muted-foreground" data-id="element-68">
              Búsqueda
            </label>
            <div className="relative" data-id="element-69">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-70" />
              <Input placeholder="Buscar..." className="pl-9 bg-muted/50" value={filters.search} onChange={e => setFilters(prev => ({
              ...prev,
              search: e.target.value
            }))} data-id="element-71" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}